/* eslint-disable no-restricted-globals */
/* eslint-disable no-undef */
import React, { useState } from 'react';

import { Auth, API } from 'aws-amplify';
import { getDriverQualificationRoleId } from '../../../graphql/customQueries';
import { Container, Col, Form, Row } from 'react-bootstrap';

import { Button } from '../../../components';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import '../styles.scoped.css';
import { setSelectedRoleId } from '../../Dashboard/dashboardSlice';

const VerifyMFACode = ({ nextStep, userData }) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [error, setErrorMessage] = useState('');
  const [countdown, setCountdown] = useState(0);

  const params = new URLSearchParams(location.search);
  const [dqf] = [params.get('dqf')];

  const timer = () => {
    setCountdown(10);
    setErrorMessage('');

    const countdownInterval = setInterval(() => {
      setCountdown(prevCountdown => prevCountdown - 1);
    }, 1000);

    setTimeout(() => {
      clearInterval(countdownInterval);

      setCountdown(0);
    }, 10000);

    nextStep({
      ...userData,
      verifyCode: '',
    });
  };

  const sendVerifyChallenge = async payload => {
    Auth.configure({ authenticationFlowType: 'CUSTOM_AUTH' });
    Auth.sendCustomChallengeAnswer(payload?.user, payload?.verifyCode)
      .then(async user => {
        if (user?.signInUserSession?.accessToken?.jwtToken) {
          if (dqf) {
            // Look up the user's actual DQF roleId from their appAccess rather than
            // hardcoding. The backend validClientDqf check then loops through the
            // UserCustomer table to confirm the customerId match for this DQF.
            try {
              const email = userData?.username || params.get('email');
              const response = await API.graphql({
                query: getDriverQualificationRoleId,
                variables: { id: email },
              });
              const items = response?.data?.getUser?.appAccess?.items ?? [];
              const roleId = items[0]?.roleId?.id ?? 2;
              dispatch(setSelectedRoleId(roleId));
            } catch (e) {
              dispatch(setSelectedRoleId(2));
            }
            // Full page navigation so Amplify re-initializes from stored tokens.
            // Brief delay lets redux-persist flush selectedRoleId to localStorage.
            setTimeout(() => {
              window.location.href = `/driver-qualification/view-dqf/${dqf}`;
            }, 100);
          } else {
            window.location.reload();
          }
        }
        if (user.challengeName === 'CUSTOM_CHALLENGE') {
          if (user.challengeParam.customMfaChallenge === 'RETRY_MFA_CODE') {
            setErrorMessage('Invalid code, try again');
            nextStep({
              ...userData,
              verifyCode: '',
            });
          }
        }
      })
      .catch(e => {
        console.log('e', e);
        if (e.code === 'LimitExceededException') {
          setErrorMessage(e.code);
        }
        if (e.code === 'NotAuthorizedException') {
          setErrorMessage(e.code);
        }
        if (e.code === 'ExpiredCodeException') {
          setErrorMessage(e.code);
        }
        if (e.message === 'Challenge response cannot be empty') {
          setErrorMessage(e.message);
        }
      });
  };

  const resendVerifyChallenge = payload => {
    if (countdown === 0) {
      timer();

      Auth.configure({ authenticationFlowType: 'CUSTOM_AUTH' });
      Auth.signIn(payload.username, payload.password).then(user => {
        if (user.challengeName === 'CUSTOM_CHALLENGE') {
          if (user.challengeParam.customMfaChallenge === 'PICK_MFA_FACTOR') {
            Auth.sendCustomChallengeAnswer(user, payload?.code).catch(e => {
              console.log('e', e);
              if (e.code === 'LimitExceededException') {
                setErrorMessage(e.code);
              }
              if (e.code === 'NotAuthorizedException') {
                setErrorMessage(e.code);
              }
              if (e.code === 'ExpiredCodeException') {
                setErrorMessage(e.code);
              }
            });
          }
        }
      });
    }
  };

  return (
    <>
      {error === 'LimitExceededException' || error === 'NotAuthorizedException' || error === 'ExpiredCodeException' ? (
        <Container fluid>
          <Row>
            <Col xs={12} className="d-flex justify-content-center mt-5 w-25">
              {error === 'LimitExceededException' && (
                <p className="border border-danger m-2 p-1 text-center text-danger">
                  Attempt limit exceeded, please try after some time.
                </p>
              )}
              {error === 'NotAuthorizedException' && (
                <p className="border border-danger m-2 p-1 text-center text-danger">Invalid user, please try again.</p>
              )}
              {error === 'ExpiredCodeException' && (
                <p className="border border-danger m-2 p-1 text-center text-danger">
                  Attempt limit exceeded, please try after some time.
                </p>
              )}
            </Col>
            <Col xs={12} className="d-flex align-items-center justify-content-center mb-4">
              <Button
                onPress={() => {
                  window.location.reload();
                }}
                variant="primary"
                text="Try Again"
              />
            </Col>
          </Row>
        </Container>
      ) : (
        <Container>
          <Row>
            <Col xs={12} className="d-flex justify-content-center mt-5 text-center w-25">
              <p className="fs-1 font-weight-bold">Please enter the code below and click Verify</p>
            </Col>
            <Col xs={12} className="d-flex justify-content-center mt-2 text-center w-25">
              {error === 'Challenge response cannot be empty' && (
                <p className="border border-danger p-2 text-danger w-50">Challenge response cannot be empty</p>
              )}
              {error === 'Invalid code, try again' && (
                <p className="border border-danger m-2 p-1 text-center text-danger w-50">
                  Invalid verification code provided, please try again
                </p>
              )}
            </Col>
            <Col xs={12}>
              <Row className="d-flex flex-col justify-content-center mb-3">
                <div className="text-center">
                  <Form.Group>
                    <Form.Label>
                      Enter Code
                      <span className="required" />
                    </Form.Label>
                    <Form.Control
                      as="input"
                      className={error.includes('Invalid code') && 'border-danger'}
                      onChange={e => {
                        if (e.target.value.length > 0) {
                          setErrorMessage('');
                        }
                      }}
                      name="verifyCode"
                      onBlur={event => {
                        nextStep({
                          ...userData,
                          verifyCode: event.target.value,
                        });
                      }}
                      style={{ textAlign: 'center', width: '100px' }}
                    />
                  </Form.Group>
                </div>
              </Row>
              <Row className="d-flex align-items-center justify-content-center mb-4">
                <Button
                  onPress={() => {
                    sendVerifyChallenge(userData);
                  }}
                  variant="secondary"
                  text="Verify"
                />
              </Row>
              <Row className="d-flex flex-col justify-content-center mb-2 text-center">
                <p className="fs-4 font-weight-bold">Didn’t get the code? Click Resend to try again</p>
              </Row>
              <Row className="d-flex flex-col justify-content-center mb-2">
                <p className="fs-1 font-weight-bold">You can Resend in {countdown} seconds</p>
              </Row>
              <Row className="d-flex align-items-center justify-content-center p-1">
                <Button
                  disabled={countdown > 0}
                  onPress={() => {
                    resendVerifyChallenge(userData);
                  }}
                  variant="secondary"
                  text="Re-send Code"
                />
              </Row>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
};

export default VerifyMFACode;
